import { FaEnvelope } from 'react-icons/fa';
import { FaGithub } from 'react-icons/fa';
import styles from './ProfileCard.module.css'

interface CardProps {
    imageUrl?: string;
    name: string;
    seeMore: string;
    withButton?:boolean;
    withIconGit?:boolean;
}

export default function ProfileCard({ imageUrl, name, seeMore, withButton, withIconGit }: CardProps){
    return(
        <div className={styles.card}>
        {imageUrl && <img src={imageUrl} alt="imagem" />}
        
        <div className={styles.container}>

        <p className={styles.cardName}>{name}</p>

        <div className={styles.cardContact}>
            <FaEnvelope className={styles.icon} size={20} data-testid="email-icon" />
            {withIconGit &&(
                <FaGithub className = {`${styles['icon-git']} ${styles.icon}`} size={20} data-testid="github-icon" />
            )}
        </div>

        {withButton && ( 
            <div className={styles.cardLinkWrapper}>
                <button className={styles.button}>{seeMore}</button>
            </div>
        )}

        </div>

    </div>
    )
}